import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptors
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn('⚠️  API User - NO TOKEN FOUND in localStorage!');
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ======================== User Management Functions ========================

/**
 * Lấy danh sách tất cả User
 */
export const fetchAllUsers = async () => {
  try {
    const response = await apiClient.get('/api/auth/allUser');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching users:', error);
    throw error.response?.data || { message: 'Failed to fetch users' };
  }
};

/**
 * Xóa User
 */
export const fetchDelUser = async (userId) => {
  try {
    const response = await apiClient.delete(`/api/auth/user/${userId}`);
    return { id: userId, ...response.data };
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error.response?.data || { message: 'Failed to delete user' };
  }
};

/**
 * Cập nhật User
 */
export const fetchUpdateUser = async (id, data) => {
  try {
    const response = await apiClient.put(`/api/auth/user/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error.response?.data || { message: 'Failed to update user' };
  }
};

/**
 * Export User ra Excel
 */
export const fetchExportUser = async (letter, startDate, endDate) => {
  try {
    const response = await fetch(
      `${BASE_URL}/api/auth/export-user?letter=${letter}&startDate=${startDate}&endDate=${endDate}`,
      { method: 'GET' }
    );

    if (!response.ok) throw new Error('Lỗi khi xuất dữ liệu');

    const blob = await response.blob();
    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = `users_${letter}_${startDate}_${endDate}.xlsx`;
    link.click();
    URL.revokeObjectURL(url);

    return { success: true, message: 'Xuất dữ liệu thành công' };
  } catch (error) {
    console.error('Error exporting user:', error);
    throw { message: 'Lỗi khi xuất dữ liệu' };
  }
};

// ======================== Default Export ========================
export default {
  fetchAllUsers,
  fetchDelUser,
  fetchUpdateUser,
  fetchExportUser,
};

